import { useDesign } from "../../hooks/libraries/designs/useDesign";
import { ServiceType } from "../../helper/serviceType";
import { DisplayManageDesignConfiguration } from "./DisplayManageDesignConfiguration";

type ManageDesignConfigurationProps = {
  designId: string;
  inputFormatId: string;
  serviceType: ServiceType;
};

export const ManageDesignConfiguration: React.FC<
  ManageDesignConfigurationProps
> = ({ designId, inputFormatId, serviceType }) => {
  const {
    query: { data: design },
  } = useDesign(designId, "published");

  if (!design) {
    return null;
  }

  return (
    <DisplayManageDesignConfiguration
      design={design}
      inputFormatId={inputFormatId}
      serviceType={serviceType}
    />
  );
};
